import { COMMONS_INIT_LOADING, COMMONS_INIT_SUCCESS, COMMONS_INIT_FAIL } from '@/store/types'

export const init = {
  [COMMONS_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [COMMONS_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [COMMONS_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  }
}
